import { render, staticRenderFns } from "./report-page-header.vue?vue&type=template&id=59c20382&"
import script from "./report-page-header.vue?vue&type=script&lang=js&"
export * from "./report-page-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports